<div class="heading py-5">
  <h1 id="alerts" class="bold font-curve-large">Alerts / Notifications</h1>
  <app-dependency-link></app-dependency-link>
</div>

<div class="alert alert-warning mb-bigger-big">
  <p>
    The following two color variants are deprecated and will be removed in the next major version of
    the styles package:
  </p>
  <ul>
    <li>
      <code>alert-error</code>
      becomes
      <code>alert-danger</code>
    </li>
    <li>
      <code>alert-notification</code>
      becomes
      <code>alert-primary</code>
    </li>
    <li>
      <code>toast-notification</code>
      becomes
      <code>toast-primary</code>
    </li>
  </ul>
</div>

<section class="continous-text">
  <h3>Usage</h3>

  <div class="alert alert-warning mb-bigger-big">
    <h5>Dismissible alerts are deprecated</h5>
    <p>
      There already exists a
      <a
        href="https://design-system.post.ch/?path=/docs/105e67d8-31e9-4d0b-87ff-685aba31fd4c--docs"
      >
        web component
      </a>
      <code>post-alert</code>
      that will handle dissmissible alerts. HTML alerts should only be used for static alerts.
    </p>
  </div>

  <div class="alert-container mt-5">
    <div class="alert alert-info">
      <p class="alert-heading">
        The markup for alerts differs from the basic bootstrap implementation, to secure
        cross-browser compatibility!
      </p>
      <p>
        While all bootstrap classes related to alerts are still available and functional, there are
        some changes to their HTMs-Markup.
      </p>
      <ul>
        <li>The close button for dismissible alerts needs to be the first tag inside the alert.</li>
        <li>Alerts have an alert-container around them.</li>
        <li>
          All alert-content needs to be wrapped in their own tag, for example a &lt;p&gt;-tag.
        </li>
        <li>
          For thematic colors, only the alerts shown on this page are available. (No "alert-light"
          or "alert-dark" available.)
        </li>
      </ul>
      <p class="bold pt-3">For Toasts, the bootstrap classes are not yet available!</p>
    </div>
  </div>
</section>

<h1>Toast / Small notification bar</h1>
<p>
  These are not meant to be put on a page directly, they should only be used overlaying the site
  content. It should always close the toast when you click on it.
</p>
<section>
  <app-toast-demo></app-toast-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateToast"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<h1>Alert / Notification bar</h1>
<p class="continous-text"></p>
<section>
  <app-alert-demo></app-alert-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateAlert"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<h1>Alert / Notification bar with action</h1>
<p class="continous-text"></p>
<section>
  <app-action-alert-demo></app-action-alert-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateAction"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<h1>Button notification</h1>
<p class="continous-text"></p>
<section>
  <app-button-notification-demo></app-button-notification-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateButton"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<h1>Overlay Notification</h1>
<p class="continous-text"></p>
<section>
  <app-overlay-notification-demo></app-overlay-notification-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateOverlay"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<h1>Notification dot</h1>
<p class="continous-text"></p>
<section>
  <app-dot-notification-demo></app-dot-notification-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplateDot"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
